import { all, fork } from 'redux-saga/effects';
import counterSaga from '../containers/Counter/saga';
import inventorySaga from '../containers/Inventory/saga';
import customersSaga from '../containers/Customers/saga';
import vendorsSaga from '../containers/Vendors/saga';
import purchasesSaga from '../containers/Purchases/saga';
import expensesSaga from '../containers/Expenses/saga';
import servicesSaga from '../containers/Services/saga';
import settingsSaga from '../containers/Settings/saga';
import tasksSaga from '../containers/Tasks/saga';

/**
 * Domain sagas run globally (not per-page) so that:
 * - AppShell's ModalProvider boot loads (sales/credits/purchases/products)
 *   actually resolve on the landing page,
 * - every view reads live API data no matter which route mounts first,
 * - modal saves work from any page.
 * Staff keeps its own injected saga (it self-loads on mount).
 */
export default function* rootSaga() {
  yield all([
    fork(counterSaga),
    fork(inventorySaga),
    fork(customersSaga),
    fork(vendorsSaga),
    fork(purchasesSaga),
    fork(expensesSaga),
    fork(servicesSaga),
    fork(settingsSaga),
    fork(tasksSaga),
  ]);
}
